module.exports = "button.btn-print-desktop,button.btn-email-desktop{width:120px}@media print{div.action-button-container button{display:none}}\n"